import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        background: {
            default: '#faecf4',
            paper: '#fff7fb'
        },
        primary: {
            main: '#00476e'
        },
        secondary: {
            main: '#ff751f'
        },
        text: {
            primary: '#00476e',
            secondary: 'rgba(0, 71, 110, 0.82)'
        }
    },
    typography: {
        fontFamily: '"Poppins", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        h1: { fontFamily: '"FF Providence Sans", "Poppins", sans-serif', fontWeight: 700 },
        h2: { fontFamily: '"FF Providence Sans", "Poppins", sans-serif', fontWeight: 700 },
        h3: { fontFamily: '"FF Providence Sans", "Poppins", sans-serif', fontWeight: 700 },
        h4: { fontFamily: '"FF Providence Sans", "Poppins", sans-serif', fontWeight: 700 },
        h5: { fontFamily: '"FF Providence Sans", "Poppins", sans-serif', fontWeight: 700 },
        h6: { fontFamily: '"FF Providence Sans", "Poppins", sans-serif', fontWeight: 700 },
        body1: { fontFamily: '"Poppins", sans-serif' },
        body2: { fontFamily: '"Poppins", sans-serif' },
        subtitle1: { fontFamily: '"Poppins", sans-serif' },
        subtitle2: { fontFamily: '"Poppins", sans-serif' },
        button: { fontFamily: '"Poppins", sans-serif', textTransform: 'none' }
    }
});

export default theme;